import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/signals/groupAssign';
import { fetchRequest as fetchGroups } from '../../actions/signals/groups';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(action) {
  const { mode, keys, group } = action.payload || {};
  try {
    const url = mode === 'unassign'
      ? `${config.API_URL}/signal/groups/unassign`
      : `${config.API_URL}/signal/groups/assign`;
    const body = mode === 'unassign' ? { keys } : { keys, group };
    const response = yield call(axios.post, url, body, { headers: getLocalUser() });
    yield put(fetchSuccess({
      mode,
      keys,
      group,
      ...(response?.data?.data?.data ?? {}),
      at: Date.now(),
    }));
    // Group counts changed; refresh the filter/autocomplete source.
    yield put(fetchGroups());
    yield put({
      type: 'SHOW_SUCCESS_SNACKBAR',
      message: mode === 'unassign'
        ? `Removed ${keys.length} signal${keys.length === 1 ? '' : 's'} from their group`
        : `Added ${keys.length} signal${keys.length === 1 ? '' : 's'} to “${group}”`,
    });
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
    yield put({
      type: 'SHOW_ERROR_SNACKBAR',
      message: 'Could not update signal groups',
    });
  }
}

export function* watch() {
  yield takeEvery(REQUEST, operation);
}
